module.exports = __webpack_public_path__ + "static/media/song3.292a6d86.mp3";